import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAdmin, isAuthenticated } from '../login/controller/login-controller';
import { ROUTES } from '../constants';

/**
 * Protected route component that allows access only to authenticated users
 * with optional admin role check
 */
const ProtectedRoute = ({ adminOnly = false, redirectPath = ROUTES.login }) => {
  const location = useLocation();
  const authenticated = isAuthenticated();
  const adminUser = isAdmin();
  const forcePasswordChange = localStorage.getItem('forcePasswordChange') === 'true';
  
  // Redirect to login if not authenticated
  if (!authenticated) {
    return <Navigate to={redirectPath} replace />;
  }

  // Force users with default password to go through profile password update first.
  if (forcePasswordChange && location.pathname !== '/profile') {
    return <Navigate to="/profile" replace />;
  }
  
  // If adminOnly flag is true, check if user is admin
  // if (adminOnly && !adminUser) {
  //   return <Navigate to={ROUTES.home} replace />;
  // }
  
  // Render child routes
  return <Outlet />;
};

export default ProtectedRoute;